import {Accordion, Col, Row} from "react-bootstrap";
import React from "react";
import {useTranslation} from "react-i18next";

export const FAQ = ({faqItems, title, subTitle}) => {
    const {t} = useTranslation();

    return (
        <section className="py-5" aria-labelledby="social">
            <Row className="justify-content-center text-center">
                <Col lg={10}>
                    <h2 id="social" className="mb-4">{title}</h2>
                    <p className="mb-4">{subTitle}</p>
                    <Accordion flush>
                        {faqItems.map((item, index) => (
                            <Accordion.Item eventKey={index.toString()} key={index}>
                                <Accordion.Header>{item.question}</Accordion.Header>
                                <Accordion.Body>{item.answer}</Accordion.Body>
                        </Accordion.Item>
                        ))}
                    </Accordion>
                </Col>
            </Row>
        </section>
    );
};
